module.exports = __webpack_public_path__ + "img/success.65e0830a.svg";